import IPlugin from "./plugin";
import VuetifyPlugin from "./vuetify.plugin";
import ServicesPlugin from "./services.plugin";
import RepositoriesPlugin from "./repositories.plugin";
import RouterPlugin from "./router.plugin";
import StorePlugin from "./store.plugin";
import SignaturePlugin from "./signature.plugin";
import VueMaskPlugin from "./vuemask.plugin";

export default class Plugins extends IPlugin {
    plugins = [
        VueMaskPlugin,
        VuetifyPlugin,
        RouterPlugin,
        StorePlugin,
        RepositoriesPlugin,
        ServicesPlugin,
        SignaturePlugin,
    ];

    setup(Vue, config) {
        config = this.plugins.reduce(
            (config, plugin) => {
                return this.plugin(plugin, Vue, config);
            },
            config
        );
        return super.setup(Vue, config);
    }

    /**
     * Add plugin
     * @param type {Function}
     * @param Vue {VueConstructor}
     * @param config {Object}
     * @returns {Object}
     */
    plugin(type, Vue, config) {
        /** @type IPlugin */
        const plugin = new type();
        return plugin.setup(Vue, config);
    }
}